import React from 'react';
import { Box, SxProps } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface ButtonContainerProps {
  children: React.ReactNode;
  sx?: SxProps;
}

export function ButtonContainer({ children, sx }: ButtonContainerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '16px',
        '& > button, & > div': {
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: (theme) =>
              `0 4px 10px ${alpha(theme.palette.common.black, 0.2)}`,
          },
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
